import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as AlarmSettings } from '@styles/icons/alarmSettings.svg';
import React from 'react';

export const AlarmSettingsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={AlarmSettings} viewBox={'0 0 20 20'} />
);

export default AlarmSettingsIcon;
